module.exports = __webpack_public_path__ + "media/images/gallery/uvvisir-24d3469113adb818d75d471002a99283.gif";